import { useRef } from "react";
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { useGetAllStockModelQuery } from "../../../features/api/modelApi";

const StockReport = () => {
  const componentRef = useRef();

  const allStockModel = useGetAllStockModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;
  const product = allStockModel?.pro;
  const modelDatas = allStockModel?.data;

  const todayDate = new Date();
  let startDay = todayDate.getDate();
  let startSmonth = todayDate.getMonth() + 1;
  let startYear = todayDate.getFullYear();
  let getTodayDate = startDay + "-" + startSmonth + "-" + startYear;

  return (
    <div className="px-12">
      <div className="flex justify-between gap-x-2 items-center py-6">
        <span>
          {" "}
          <ReactToPrint
            trigger={() => (
              <h1 className="cursor-pointer text-red-400">( print )</h1>
            )}
            content={() => componentRef.current}
            pageStyle="@page { size: A4;  margin: 1cm; } @media print { body { -webkit-print-color-adjust: exact; } }"
          />
        </span>
      </div>
      <div className="overflow-auto w-full p-1 pb-6 m-auto" ref={componentRef}>
        <div className="text-center mb-2">
          <p className=" text-xl pb- font-bold">Johura Endomed Solution</p>
          <p className="font-bold"> Stock Report </p>
          <p>Date: {getTodayDate}</p>
        </div>

        <div>
          {product?.map((pro) => {
            return (
              <div key={pro?.id}>
                <h1 className="text-lg font-bold my-2">{pro?.name}</h1>
                <table className="table-auto w-full">
                  <thead
                    className="border "
                    style={{ backgroundColor: "#f0f0f5" }}
                  >
                    <tr>
                      <th className="px-4 py-2">Model</th>
                      <th className="px-4 py-2">Opening</th>
                      <th className="px-4 py-2">Purchase</th>
                      <th className="px-4 py-2">Sales</th>
                      <th className="px-4 py-2">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modelDatas
                      ?.filter((item) => item?.proId == pro?.id)
                      ?.map((m) => (
                        <tr key={m?.model_id}>
                          <td className="border px-4 py-2">{m?.model_name}</td>
                          <td className="border px-4 py-2 text-center">
                            {m?.open_qty}
                          </td>
                          <td className="border px-4 py-2 text-center">
                            {m?.pur_qty}
                          </td>
                          <td className="border px-4 py-2 text-center ">
                            <Link to="/dashboard/report/stock/sales">
                              {m?.sale_qty}
                            </Link>
                          </td>
                          <td className="border px-4 py-2 text-center text-black font-bold">
                            {m?.avl_qty}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StockReport;
